export enum ProofOfDeliveryRule {
  INHERITED  = 'INHERITED',
  BOTH       = 'BOTH',
  SIGNATURES = 'SIGNATURES',
  PHOTO      = 'PHOTO',
}
